export default function ($translate) {
    return {
        KEYS: {
            IN_CONFIRMATION: 'IN_CONFIRMATION',
            CONFIRMED: 'CONFIRMED',
            DECLINED: 'DECLINED',
            WAITING_FOR_DIRECT_MANAGER: 'WAITING_FOR_DIRECT_MANAGER',
            CONFIRMED_BY_DIRECT_MANAGER: 'CONFIRMED_BY_DIRECT_MANAGER',
            NEED_DETAILS: 'NEED_DETAILS',
            CANCELLED: 'CANCELLED'
        },
        LABELS: {
            IN_CONFIRMATION: $translate.instant('course.external.participation.In confirmation'),
            CONFIRMED: $translate.instant('course.external.participation.Confirmed'),
            DECLINED: $translate.instant('course.external.participation.Declined'),
            WAITING_FOR_DIRECT_MANAGER: $translate.instant('course.external.participation.Waiting for direct manager'),
            CONFIRMED_BY_DIRECT_MANAGER: $translate.instant('course.external.participation.Approved by direct manager'),
            NEED_DETAILS: $translate.instant('course.external.participation.Requires details'),
            CANCELLED: $translate.instant('course.external.participation.Cancelled')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/externalParticipationStatusType/index.js